import * as React from 'react';
import styled from 'styled-components';
import theme from 'theme';
import config from 'config';

const List = styled.ul`
    height: 100%;
    list-style: none;
    margin: 0;

    @media (max-width: 985px) {
        display: none;
    }
`;

const MainSection = styled.button`
    background-color: #fff;
    color: #777;
    margin: 0;
    padding: 0;
    text-transform: uppercase;
    transition: color 0.2s;

    &:after {
        background-color: ${theme.colors.main};
        bottom: 10px;
        content: '';
        height: 2px;
        left: 0;
        position: absolute;
        transition: width 0.4s;
        width: 0;
    }
`;

const Dropdown = styled.ul`
    border: 1px solid ${theme.colors.main_light};
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
    display: none;
    left: 0;
    min-width: 300px;
    position: absolute;
    top: 100%;
    z-index: 2;
`;

const DropdownItem = styled.li`
    background-color: #ffffff;
    list-style: none;
    transition: background-color 0.3s;

    &:hover {
        background-color: #f1f1f1;
    }

    a {
        color: ${theme.colors.text};
    }

    div {
        padding: 15px 20px;
    }
`;

const Section = styled.li`
    align-items: center;
    display: inline-flex;
    font-family: 'Open Sans', sans-serif;
    height: 100%;
    justify-content: center;
    min-width: 100px;
    padding: 15px 10px;
    position: relative;

    &:hover {
        ${Dropdown} {
            display: block;
        }

        ${MainSection} {
            color: ${theme.colors.text};

            &:after {
                width: 100%;
            }
        }
    }
`;

const sections = [
    {
        title: 'Yritykset',
        children: [
            { title: 'Yrityshaku', path: '/palvelut/yritykset/yrityshaku/' },
            {
                title: 'European Business Register',
                path: '/palvelut/yritykset/yrityshaku/ebr'
            },
            {
                title: 'Balance Intelligence',
                path: '/yritykset/balance-intelligence/'
            },
            {
                title: 'Konkurssit ja yrityssaneeraukset',
                path: '/yritykset/konkurssit-ja-yrityssaneeraukset/'
            },
            {
                title: 'Yhdistysrekisteri',
                path: '/yritykset/yhdistysrekisteri/'
            }
        ]
    },
    {
        title: 'Analysaattori',
        children: [
            {
                title: 'Analysaattori',
                path: `${config.baseName}/`
            }
        ]
    },
    {
        title: 'Kiinteistöt',
        children: [
            {
                title: 'Kiinteistöhaku ja karttapalvelu',
                path: '/palvelut/kiinteistot/kiinteistohaku/haku/'
            },
            {
                title: 'Kiinteistö- ja huoneistohaku BETA',
                path: '/kiinteistohaku/'
            },
            {
                title: 'Kauppahintahaku',
                path:
                    '/palvelut/kiinteistot/kiinteistohaku/haku/#/real-estate-releases-search-tab'
            },
            {
                title: 'Asukaskysely',
                path:
                    '/kiinteistot/asukaskysely/yhtioiden-ja-rakennusten-hallinta/'
            },
            {
                title: 'Kiinteistökaupan luonnostelupalvelu',
                path: '/kiinteistot/kiinteistokaupan-luonnostelupalvelu/'
            },
            {
                title: 'Kiinteistökaupan luonnostelupalvelun koulutusympäristö',
                path:
                    '/kiinteistot/kiinteistokaupan-luonnostelupalvelu-koulutusymparisto/'
            }
        ]
    },
    {
        title: 'Henkilöt',
        children: [
            {
                title: 'Henkilö- ja osoitehaku',
                path: '/henkilot/henkilo-ja-osoitehaku/'
            },
            { title: 'Maksuhäiriöt', path: '/henkilot/maksuhairiot/' },
            {
                title: 'Liiketoimintakiellot',
                path: '/henkilot/liiketoimintakiellot/'
            },
            { title: 'Velkajärjestelyt', path: '/henkilot/velkajarjestelyt/' },
            { title: 'Avioehtoasiat', path: '/henkilot/avioehtoasiat/' },
            { title: 'Lahjoitusasiat', path: '/henkilot/lahjoitusasiat/' },
            {
                title:
                    'Poliittinen vaikutusvalta ja Tosiasiallinen edunsaaja -lomakkeet',
                path: ''
            }
        ]
    },
    {
        title: 'Kohderyhmät',
        children: [{ title: 'Kohderyhmähaku', path: `/kohderyhmahaku/` }]
    },
    {
        title: 'Asiakaspalvelu',
        children: [
            { title: 'Ajankohtaista', path: '/' },
            {
                title: 'Blogi',
                path:
                    'https://www.almatalent.fi/tietopalvelut/asiakaspalvelu/blogi/'
            },
            {
                title: 'Palveluesittely',
                path:
                    'https://www.almatalent.fi/tietopalvelut/palvelut/yritystietopalvelut/analysaattori'
            },
            {
                title: 'Yhteystiedot',
                path:
                    'https://www.almatalent.fi/tietopalvelut/asiakaspalvelu/yhteystiedot'
            }
        ]
    }
];

const TietopalvelutNav = () => (
    <List className="no-print">
        {sections.map(section => (
            <Section key={section.title}>
                <MainSection>{section.title}</MainSection>
                <Dropdown>
                    {section.children.map(child => (
                        <DropdownItem key={child.title}>
                            <a href={child.path} rel="noopener">
                                <div>{child.title}</div>
                            </a>
                        </DropdownItem>
                    ))}
                </Dropdown>
            </Section>
        ))}
    </List>
);

export default TietopalvelutNav;
